var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.72C12 6.47161 12 6.34742 12.0567 6.24546C12.1028 6.1624 12.1921 6.08326 12.2801 6.04738C12.3881 6.00333 12.4981 6.0166 12.7183 6.04315C13.52 6.13981 14.2964 6.39764 15 6.80385C15.9121 7.33046 16.6695 8.08788 17.1962 9C17.7228 9.91212 18 10.9468 18 12C18 13.0532 17.7228 14.0879 17.1962 15C16.6695 15.9121 15.9121 16.6695 15 17.1962C14.0879 17.7228 13.0532 18 12 18C10.9468 18 9.91211 17.7228 9 17.1962C8.29643 16.7899 7.68491 16.2464 7.20036 15.6005C7.0673 15.4231 7.00077 15.3344 6.98491 15.2189C6.97199 15.1247 6.9959 15.0078 7.04475 14.9263C7.10472 14.8263 7.21227 14.7642 7.42739 14.64L11.64 12.2078C11.7711 12.1321 11.8367 12.0943 11.8844 12.0413C11.9266 11.9944 11.9585 11.9392 11.978 11.8793C12 11.8115 12 11.7357 12 11.5843V6.72Z",
    fill: "#222222"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8.5,
    stroke: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.0d1d51f78a19d0a11b5e13b1b355f722.svg";
export { ForwardRef as ReactComponent };